import React, { useState } from "react";

const MeditationTracking = () => {
  const meditationData = [
    { date: "20/11/2024", name: "Meditation 1", time: "20 Mins" },
    { date: "21/11/2024", name: "Meditation 2", time: "15 Mins" },
    { date: "22/11/2024", name: "Meditation 3", time: "30 Mins" },
    { date: "23/11/2024", name: "Meditation 4", time: "25 Mins" },
    { date: "24/11/2024", name: "Meditation 5", time: "20 Mins" },
    { date: "25/11/2024", name: "Meditation 6", time: "35 Mins" },
    { date: "26/11/2024", name: "Meditation 7", time: "40 Mins" },
    { date: "27/11/2024", name: "Meditation 8", time: "15 Mins" },
    { date: "28/11/2024", name: "Meditation 9", time: "25 Mins" },
    { date: "29/11/2024", name: "Meditation 10", time: "20 Mins" },
    { date: "30/11/2024", name: "Meditation 11", time: "30 Mins" },
    { date: "01/12/2024", name: "Meditation 12", time: "10 Mins" },
    { date: "02/12/2024", name: "Meditation 13", time: "50 Mins" },
    { date: "03/12/2024", name: "Meditation 14", time: "45 Mins" },
    { date: "04/12/2024", name: "Meditation 15", time: "15 Mins" },
    { date: "05/12/2024", name: "Meditation 16", time: "20 Mins" },
    { date: "06/12/2024", name: "Meditation 17", time: "30 Mins" },
    { date: "07/12/2024", name: "Meditation 18", time: "25 Mins" },
    { date: "08/12/2024", name: "Meditation 19", time: "40 Mins" },
    { date: "09/12/2024", name: "Meditation 20", time: "35 Mins" },
  ];

  const [isFeatureReady] = useState(false);

  return (
    <div className="container mt-4">
      <h6 className="text-start fw-bold">Meditation Tracking</h6>

      <div className="mb-4">
        <div className="card-body" style={{ position: "relative" }}>
          <div
            className="table-responsive"
            style={{
              maxHeight: "300px",
              borderRadius: "10px",
              opacity: isFeatureReady ? 1 : 0.5,
            }}
          >
            <table className="table table-bordered mb-0 rounded-3">
              <thead
                className="bg-success text-white table-primary"
                style={{ position: "sticky", top: "0", zIndex: "1" }}
              >
              <tr>
                <th className="text-start ps-3">Date</th>
                <th className="text-start ps-3">Name</th>
                <th className="text-start ps-3">Time</th>
              </tr>
              </thead>

              <tbody>
              {meditationData.map((item, index) => (
                <tr key={index}>
                  <td className="text-start ps-3">{item.date}</td>
                  <td className="text-start ps-3">{item.name}</td>
                  <td className="text-start ps-3">{item.time}</td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>

          {!isFeatureReady && (
            <div
              className="alert alert-warning text-center"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                zIndex: "10",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            >
              <h4>Feature Coming Soon!</h4>
              <p>Stay tuned for future updates.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MeditationTracking;
